import type { ParsedInsightsFilters } from '@/common/api/types/dashboard/filters';

type HealthQueryKeyParams = {
  filters?: ParsedInsightsFilters;
  scopeItemId?: number;
  loopId?: number;
  orgId?: string;
};

export const reportingStoreQueryKeys = {
  health: {
    all: () => ['insightsHealthSummary'] as const,
    summary: ({ filters, scopeItemId, loopId, orgId }: HealthQueryKeyParams) => [
      'insightsHealthSummary',
      orgId,
      loopId,
      filters,
      scopeItemId,
    ],
    allItemHealth: () => ['insightsItemHealth'] as const,
    byItemIds: (itemIds: number[]) => ['insightsItemHealth', itemIds] as const,
    byItemId: (itemId: number) => ['insightsItemHealth', itemId] as const,
  },
} as const;
